import React from 'react'
import { Button } from 'components'
import { PlusIcon, MinusIcon } from 'assets/icons'

import './ChooseAmount.scss'

interface Props {
    max: number,
    step: number,
    onUpdate: Function
}
interface State {
    quantity: number,
    max: number
}

export default class ChooseAmount extends React.Component<Props, State> {

    static getDerivedStateFromProps ( nextProps: Props, prevState: State ) {

        if (nextProps.max !== prevState.max) {
            return {
                quantity: 0,
                max: nextProps.max
            }
        } else {
            return nextProps
        }
    }

    constructor(props: Props) {
        super(props)
        this.state = {
            quantity: 0,
            max: 0
        }
    }

    public round = (quantity: number, increment: number, offset: number) =>
        Math.ceil((quantity - offset) / increment ) * increment + offset

    public handleUpdate = (value: number) => {
        this.props.onUpdate(value)
    }
    public increment = () => {
        let newquantity = this.round(this.state.quantity + this.props.step, this.props.step, 0)
        this.setState( state => ({
            quantity: newquantity > this.state.max ? this.state.max : newquantity
        }))
        this.handleUpdate(newquantity > this.state.max ? this.state.max : newquantity)
    }

    public decrement = () => {
        let newquantity = this.round(this.state.quantity - this.props.step, this.props.step, 0)
        this.setState({
            quantity: newquantity < 0 ? 0 : newquantity
        })
        this.handleUpdate(newquantity < 0 ? 0 : newquantity)

    }

    render() {

        return (
            <div id="choose-amount">
                <div className="column">
                    <Button variant="round" className="minus" onClick={this.decrement}>
                        <MinusIcon fill="#7A7974"/>
                    </Button>
                </div>
                <div className="column amounts">
                    <b>{this.state.quantity}</b>/{this.state.max}
                </div>
                <div className="column">
                    <Button variant="round" className="plus" onClick={this.increment}>
                        <PlusIcon fill="#7A7974"/>
                    </Button>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/ChooseAmount/index.tsx